"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indonesiaTranslations = void 0;
var _types = require("../../../types");
const indonesiaTranslations = exports.indonesiaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Mohon maaf!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Kembali',
  [_types.ErrorPageTranslationKey.text]: 'Halaman ini sedang dalam perbaikan',
  [_types.ErrorPageTranslationKey.notFound]: 'Halaman tidak ditemukan',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Halaman yang ingin Anda buka dibatasi dan tidak semua kriteria terpenuhi.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Silakan hubungi tim dukungan Oriflame melalui email:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'URL yang diminta ditolak!'
};
